import { NOTIFY } from './notifications.types';

// eslint-disable-next-line import/prefer-default-export
export const notify = (text, options) => ({
  type: NOTIFY,
  payload: { text, options },
});
